import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import Button from '../../../components/buttons/Button';
import { useTranslation } from 'react-i18next';
import OrderStepsTable from '../../../modules/orderSteps/components/OrderStepsTable';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import { hasPermission } from '../../../utils/HelperFunctions';

const OrderSteps = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle, searchEle } = useModuleTableHelpers({
    route: 'admin/order-steps',
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('order_steps'),
    withPagination: true,
    queryKey: 'order-steps',
  });



  const tableHeaders = [
    { label: t('name_en'), customClass: 'text-center' },
    { label: t('name_ar'), customClass: 'text-center' },
    { label: t('order'), customClass: 'text-center' },
    hasPermission(['order_steps.edit']) && { label: t('actions'), customClass: 'text-center' }
  ];

  if (apiDataLoading ) return <TableSkeleton columns={5} withoutButton />;

  return (
    <div className="order-steps-page-container">
      <ListHeader customClass='table_filters'>
        {/* <div className="filter_container">{searchEle}</div> */}
        {hasPermission(['order_steps.edit']) && <Button text={t('create_order_step')} link="/order-steps/create-order-step" />}
      </ListHeader>

      <OrderStepsTable
        tableHeaders={tableHeaders}
        data={apiData}
        noDataMessage={t('no_order_steps_found')}
        lessColumns
      />
      {paginationEle}
    </div>
  );
};

export default OrderSteps;
